export default __webpack_public_path__ + "static/media/Camera_Black.5d0a1b67.webp";